import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { GOLD } from '../../utils/constant';

const Header = ({ goToPreviousTab, isHomePage }) => {
  const heading = useSelector((state) => state.header.heading);
  const memberShip = useSelector((state) => state.membership.memberShip);
  const tiers = localStorage.getItem('customerTier');

  return (
    <header>
      <div className="header-top">
        <div className="header-top-left">
         <div className="makeflex align-center">
          <Link to="#" onClick={(e) => { e.preventDefault(); goToPreviousTab(); }} >
           
              <img src="/images/back.png" alt="Back" />
           </Link>
            <h4>{heading}</h4>
            </div>
        
           
            
              
            
        </div>
        <div className="header-top-right">
          <ul className="makeflex align-center justify-end gap-05">
            <li className="notification">
              <img src="/images/bell.png" alt="" />
            </li>
            <li className="user-badge gap-01">
              <p>{tiers}</p>
              <img
                src={
                  memberShip === GOLD
                    ? '/images/gold.png'
                    : '/images/silver-badge.png'
                }
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
